import React from 'react'
import Footer from '../component/Footer/Footer'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import TextContent from '../component/TextContent/TextContent'
import ProjectManagmentForm from '../component/ProjectManagmentForm/ProjectManagmentForm'
import { Helmet } from 'react-helmet'

function ProjectManagement() {
  return (
    <div>
      <Helmet>
          <title> 
          Project Management Services in GTA | Home Renovation Experts
          </title>
          <meta 
          name='description' 
          content="Looking for reliable project management services in the GTA? MES Décors delivers stress-free home and interior renovation management in Toronto — on time, on budget, and with design precision." 
          />
          <link rel="canonical" href="https://www.mesdecors.ca/project-management" />

        </Helmet>
        
      <HeroBanner
        subHeading=""
        Heading="Project Management Services in GTA – Stress-Free, On-Time, and On-Budget"
        nextLineSpanHeading=""
        Paragraph="From planning to completion, MES Décors offers professional project management services for homeowners in GTA. Whether it’s a home renovation project, interior design upgrade, or commercial fit-out, our team manages every step with precision, expertise, and trusted local partners."
        bgImg="/images/creatives/project-management-hero-bg.png"
        btn={false}
        sideLinks={false}
      />

      <TextContent
        subHeading=""
        heading="Why Choose MES Décors for Project Management?"
        content={`Managing a renovation project in the GTA can be overwhelming—coordinating trades, handling timelines, tracking budgets, and ensuring the final result matches your vision. That’s where a trusted GTA project management company like MES Décors makes the difference.`}
        postNormalHeading="With MES Décors, you get:"
        customList={true}
        customListData={[
          "<p class='body-paragraph'><b>One Point of Contact :</b> We handle communication with all contractors, suppliers, and vendors.</p>",
          "<p class='body-paragraph'><b>Budget Control :</b> Transparent pricing, accurate cost tracking, and no surprises.</p>",
          "<p class='body-paragraph'><b>On-Time Delivery :</b> Streamlined scheduling to keep your construction project management GTA running smoothly.</p>",
          "<p class='body-paragraph'><b>Quality Assurance :</b> Every stage is supervised for flawless execution.</p>",
          "<p class='body-paragraph'><b>Design Integration :</b> As interior design project management experts, we align functionality with aesthetic goals.</p>",
          "<p class='body-paragraph'><b>Client Representation :</b> Not available? We represent you during critical meetings to keep the project moving forward.</p>",
        ]}
        btn={false}
        btnText="Get A QUOTE"
        btnRef="/get-a-quote"
        btnRefTel={false}
        shiftRow={false}
        img="/images/creatives/project-management-text-1.png"
        reviewContent={false}
        btnImg={false}
        fontDark={true}
      />
      <TextContent
        subHeading=""
        heading="Our Project Management Services in the GTA"
        content={``}
        customList={true}
        customListData={[
          "<p class='body-paragraph color-light'><b>Interior Renovations –</b> Kitchens, bathrooms, basements, and living spaces managed by a dedicated interior renovation project manager.</p>",
          "<p class='body-paragraph color-light'><b>Commercial Fit-Outs –</b> End-to-end commercial project management GTA for offices, retail spaces, and restaurants.</p>",
          "<p class='body-paragraph color-light'><b>Full-Service Interior Design Projects –</b> Concept to completion execution.</p>",
          "<p class='body-paragraph color-light'><b>Home Staging Installations –</b> Stress-free, professionally managed setups.</p>",
          "<p class='body-paragraph color-light'><b>Trade & Vendor Coordination –</b> Hire a project manager to coordinate trades, budgets, and timelines in GTA.</p>",
          "<p class='body-paragraph color-light'><b>Furniture, Fixture & Equipment Procurement –</b> Seamless sourcing and installation.</p>",
        ]}
        btn={false}
        btnText="Get A QUOTE"
        btnRef="/get-a-quote"
        btnRefTel={false}
        shiftRow={true}
        img="/images/creatives/project-management-text-2.png"
        reviewContent={false}
        btnImg={false}
        fontDark={false}
        endContentPara={
          "Whether you’re redesigning a home or preparing a business space, MES Décors delivers <b>end-to-end project management for residential and commercial spaces in the GTA.</b>"
        }
      />
      <TextContent
        subHeading=""
        heading="Why GTA Trusts MES Décors"
        content={``}
        customList={true}
        customListData={[
            "<p class='body-paragraph'><b>20+ Years in Sales & Operations Management –</b> Proven leadership in large-scale projects.</p>",
            "<p class='body-paragraph'><b>15+ Years in Interior Design & Staging –</b> Expertise in interior design and renovation project management GTA with trusted local contractors.</p>",
            "<p class='body-paragraph'><b>Local GTA Network –</b> Access to vetted trades, suppliers, and professionals.</p>",
            "<p class='body-paragraph'><b>Transparent & Ethical Process –</b> You stay informed every step of the way.</p>"
        ]}
        btn={false}
        btnText="Get A QUOTE"
        btnRef="/get-a-quote"
        btnRefTel={false}
        postListHeading="Your Reliable Project Manager in GTA"
        endContentPara='Whether it’s <b>residential project management in the GTA</b> or <b>trusted project management for commercial fitouts in GTA</b>, MES Décors ensures projects are delivered stress-free, on-time, and on-budget. Looking for <b>affordable project management services for small businesses in GTA</b> or wondering <b>how to find a reliable renovation project manager in the GTA?</b> Start with MES Décors.'
        shiftRow={false}
        img="/images/creatives/project-management-text-3.png"
        reviewContent={false}
        btnImg={false}
        fontDark={true}
      />

      <ProjectManagmentForm
        mainPara={"Ready to start your next renovation, design, or staging project with a trusted GTA project management company? Fill out the form below and our team will connect with you."}
        emailTitle="Message genrated through Project Management form"
      />

      <Footer newsletterSection={true} />
    </div>
  );
}

export default ProjectManagement